const Loader = () => {
    return (
        <div className='fixed left-0 right-0 bottom-0 top-0 w-full h-full backdrop-blur-xl bg-neutral-900/40 z-[100] flex items-center justify-center animate-fade-in'>
            <div className="relative">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-accent animate-[gradient-shift_3s_ease_infinite] bg-[length:200%_200%]"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-10 h-10 rounded-full bg-white"></div>
                </div>
                <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-spin"></div>
            </div>
        </div>
    )
}

export default Loader
